var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"width":_vm.largura}}),_vm._v("\n  "+_vm._s(_vm.preencherGrafico)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }